import { render, staticRenderFns } from "./newOaWorkflowFormEditList.vue?vue&type=template&id=24b50c58&scoped=true"
import script from "./newOaWorkflowFormEditList.vue?vue&type=script&lang=js"
export * from "./newOaWorkflowFormEditList.vue?vue&type=script&lang=js"
import style0 from "./newOaWorkflowFormEditList.vue?vue&type=style&index=0&id=24b50c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b50c58",
  null
  
)

export default component.exports